import React, {useMemo} from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import {useRouter} from 'next/router'

import {createLog} from '@util/logs'
import {ILoginInfoData} from '@store/LoginStore'
import {useLoginModalStore} from '@store/LoginModalStore'
import useAccounts from '@hook/useAccounts'
import useSnackbar from '@hook/useSnackbar'

import Text from '@component/Text/Text'
import ProTag from '@component/tags/ProTag'
import UserThumbnail from '@component/images/UserThumbnail'

interface IProps {
    className?: string
    user: ILoginInfoData
}

const UserAccountListItem = ({className, user}: IProps) => {
    const t = useTranslation()
    const router = useRouter()
    const {showSnackbar} = useSnackbar()

    const {login} = useAccounts()
    const showLoginModal = useLoginModalStore(state => state.showLoginModal)

    const isCheckOverLoginTime = useMemo(() => new Date().getTime() > user?.login_end_at, [user?.login_end_at])

    const onClickChangeAccount = (user: ILoginInfoData, isCheckOverLoginTime: boolean) => {
        createLog('event', 'navigation_change_account', {user_id: user?.id})

        if (isCheckOverLoginTime) {
            showLoginModal()
            return
        }

        const userName = router?.locale === 'ko' && user?.nickname ? user?.nickname : user?.name
        login(user?.id, user?.access_token)
        showSnackbar(t('globalNavigation.multiLogin.changeAccount.text', {username: userName}))
        localStorage.removeItem('isCheckInvoiceModal')
    }

    return (
        <div
            onClick={() => onClickChangeAccount(user, isCheckOverLoginTime)}
            className={`px-[30px] flex items-center space-x-[10px] py-[7px] cursor-pointer hover:bg-gray07 dark:hover:bg-dark_gray07 ${className}`}>
            <UserThumbnail
                src={user?.thumbnail}
                size={20}
                isPro={user?.isPro ?? false}
                containerClassName={'flex-none'}
            />
            <div className={'flex-1 truncate max-w-[100%]'}>
                <Text className={'text-body2 text-gray02 dark:text-dark_gray02 truncate'}>
                    {router?.locale === 'ko' ? user?.nickname || user?.name : user?.name}
                </Text>
            </div>
            {isCheckOverLoginTime && (
                <Text className={'text-body3 text-gray02 dark:text-dark_gray02'}>
                    {t('globalNavigation.multiLogin.expire')}
                </Text>
            )}
            {user?.isPro && <ProTag size={'small'} />}
        </div>
    )
}
export default UserAccountListItem
